import { type OperationResult } from 'urql';
import { createModel } from 'xstate/lib/model';

import { type CustomerQuery } from './graphql/customer.generated';
import { initAuthBroadcastChannel } from './utils';

// ─────────────────────────────────────────────────────────────────────────────

export const AuthModel = createModel(
  {
    authBroadcastChannel: initAuthBroadcastChannel(),
    currentCustomer: null as CurrentCustomerContextData,
    postLoginRedirectHref: undefined as string | undefined,
    isFirstAuthAttempt: true,
  },
  {
    events: {
      LOGOUT: (csrfToken?: string) => ({ csrfToken }),
      LOGIN: (csrfToken?: string, postLoginRedirectHref?: string) => ({
        csrfToken,
        postLoginRedirectHref,
      }),
      INIT_LOGGED_IN_SESSION: (csrfToken: string) => ({ csrfToken }),
      INIT_GUEST_SESSION: (csrfToken: string) => ({ csrfToken }),
      UPDATE_CSRF_TOKEN: (csrfToken: string) => ({ csrfToken }),
      CLEAR_POST_LOGIN_REDIRECT_HREF: () => ({}),
    },
  },
);

// ─── Types ───────────────────────────────────────────────────────────────────

export type CurrentCustomerContextData =
  | NonNullable<OperationResult<CustomerQuery, Record<string, unknown>>['data']>['currentCustomer']
  | null;
